import * as React from 'react'
import { connect } from 'react-redux'

import { Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from 'src/store/rootReducer'
import { User } from 'src/lib/interfaces/User.interface'

import CustomSelect from 'src/common/CustomSelect.component'

import * as authActions from 'src/store/auth/actions'
import * as adminActions from 'src/store/admin/actions'

import { formatName } from 'src/lib/helpers/format'

const find = require('lodash/find')
const filter = require('lodash/filter')

export interface RoleAssumptionModalProps {
  user: User
	open: boolean
	users?: User[]
  onToggle: () => void
  isFetchingUsers: boolean
  assumeRoleFromUser: (user?: User) => void
  fetchUsersList: (next?: (err?: any, users?: User[]) => void) => void
}

interface RoleAssumptionModalState {
  selectedUserId?: number
}

class RoleAssumptionModal extends React.PureComponent<RoleAssumptionModalProps, RoleAssumptionModalState> {
  state = {
    selectedUserId: undefined
  }

  get usersToShow() {
    const { user, users } = this.props
    return filter(users, u => u.id !== user.id)
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props
    const { open: prevOpen } = prevProps

    if (open !== prevOpen) {
      this.setState({ selectedUserId: undefined })

      if (open) {
        this.props.fetchUsersList()
      }
    }
  }

  handleClose = () => {
    this.props.onToggle()
    this.setState({ selectedUserId: undefined })
  }

  handleAssumeRole = () => {
    const { selectedUserId } = this.state
    const { users, assumeRoleFromUser } = this.props

    const user = find(users, { id: selectedUserId })
    assumeRoleFromUser(user)
    this.handleClose()
  }

  render() {
    const { selectedUserId } = this.state
    const { open, onToggle, isFetchingUsers } = this.props

    return (
      <Modal
        size="md"
        isOpen={open}
        toggle={onToggle}
      >
        <ModalHeader toggle={onToggle}>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon
              className="mr-2"
              spin={isFetchingUsers}
              icon={isFetchingUsers ? ['fas', 'spinner'] : ['fas', 'glasses']}
            />
            Assume role...
          </div>
        </ModalHeader>

        <ModalBody>
          <CustomSelect
            value={selectedUserId}
            options={this.usersToShow}
            disabled={isFetchingUsers}
            getOptionValue={option => option.id}
            valueContainerStyle={{ textAlign: 'left' }}
            onChange={(value: number) => this.setState({ selectedUserId: value })}
            getOptionLabel={option => formatName(option.employee) || 'Unnamed user'}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            onClick={this.handleAssumeRole}
            disabled={!selectedUserId || isFetchingUsers}
          >
            Continue
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  users: state.admin.users,
  isFetchingUsers: state.admin.isFetchingUsers
})

const mapDispatchToProps = dispatch => ({
  assumeRoleFromUser: (user?: User) => dispatch(authActions.assumeRoleFromUser(user)),
  fetchUsersList: (next?: (err?: any, users?: User[]) => void) => dispatch(adminActions.fetchUsersList(next))
})

export default connect(mapStateToProps, mapDispatchToProps)(RoleAssumptionModal)



// WEBPACK FOOTER //
// ./src/routes/employees/components/RoleAssumption.modal.tsx